import { graphql } from '../../gql';

export default graphql(`
    mutation LogOut {
        invalidateTokens {
            ok
        }
    }
`);
